<div class="form-group">
    <label for="">{{labelName}}</label>
    <input #input type="text" class="form-control" (blur)="onBlur()" (focus)="onFocus = true" aria-describedby="helpId"
        placeholder="" [(ngModel)]="textToSearch" (ngModelChange)="textChanged()">
    <div #dataList class="data-list" [ngStyle]="{'width.px': input.offsetWidth}"
        [ngClass]="{'fadeIn': onFocus, 'fadeOut': !onFocus}">
        <div class="data-list-option" *ngFor="let item of filteredDataItems"
            [ngClass]="{'active': item == lastActivedItem}" (mouseover)="mouseOverOption(item)"
            (click)="itemClicked()">
            {{item.description}}
        </div>
    </div>
</div>
<ng-content>
</ng-content>